<template>
  <div v-if="snackbar === true">
    <v-alert
      text
      prominent
      type="error"
    >
      {{ snackbarMessage }}
    </v-alert>
  </div>
  <div v-else>
    <iframe
      id=looker
      title=""
      width="100%"
      height="800"
      :src="embedUrl"
    ></iframe>
  </div>
</template>

<script>

export default {
  name: 'Dashboard',
  props: ['user', 'dashboardUrl', 'dashboardType'],
  components: {
  },
  data: function () {
    return {
      embedUrl: '',
      snackbar: false,
      snackbarMessage: ''
    }
  },
  created: async function () {
    await this.generateEmbedUrls()
  },
  methods: {
    generateEmbedUrls: async function () {
      const userProfile = this.user
      const currUser = {}
      currUser.email = userProfile.userName
      currUser.externalId = userProfile.accountIdentifier
      currUser.firstName = userProfile.name.split(' ').slice(0, -1).join(' ')
      currUser.lastName = userProfile.name.split(' ').slice(-1).join(' ')
      const userLookerProfile = this.user.profile[0]
      const userAttributes = await this.getUserBrandAttribute(userLookerProfile.id)
      //   // Group id - 12 Sales Portal
      //   // Group id - 11 Brand Portal
      currUser.groupId = userLookerProfile.group_ids
      if (this.dashboardType === 'sales') {
        if (userAttributes) {
          const body = {
            target_url: this.dashboardUrl,
            session_length: 2592000,
            force_logout_login: true,
            external_user_id: currUser.email,
            first_name: currUser.firstName,
            last_name: currUser.lastName,
            permissions: ['see_user_dashboards', 'see_lookml_dashboards', 'access_data', 'see_looks'],
            models: ['external_partner_portals'],
            group_ids: [12],
            user_attributes: { brand: userAttributes[0].value, parent_company: userAttributes[1].value }
          }
          await this.setEmbedUrl(body)
        } else {
          this.snackbar = true
          this.snackbarMessage = 'Please contact your brand rep and have them assign your brand to your user account. Try again once you have a brand associated with your user account.'
        }
      }

      if (this.dashboardType === 'brand') {
        const body = {
          target_url: this.dashboardUrl,
          session_length: 2592000,
          force_logout_login: true,
          external_user_id: currUser.email,
          first_name: currUser.firstName,
          last_name: currUser.lastName,
          permissions: ['see_user_dashboards', 'see_lookml_dashboards', 'access_data', 'see_looks'],
          models: ['external_partner_portals'],
          group_ids: [11],
          user_attributes: { brand: userAttributes[0].value, parent_company: userAttributes[1].value }
        }
        await this.setEmbedUrl(body)
      }
    },
    getUserBrandAttribute: async function (userId) {
      return fetch(`/api/user/userattr/${userId}`)
        .then(response => response.json())
    },
    setEmbedUrl: async function (body) {
      fetch('/api/embed', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(res => res.json())
        .then(data => {
          if (data.url) {
            this.embedUrl = data.url
            // console.log(`embedUrl: ${this.embedUrl}`)
          } else {
            console.log('Error:', data.message)
          }
        })
    }
  }
}
</script>

<style scoped>

</style>
